import { useFormikContext } from 'formik'
import { useEffect } from 'react'

import { SearchFormState } from '@components/SearchForm'
import emarsys from '@lib/analytics/emarsys'

const SearchAnalytics = () => {
  const { values } = useFormikContext<SearchFormState>()

  useEffect(() => {
    if (!values?.departureLocation?.name) return

    emarsys.search.sendLocation('origin', values.departureLocation?.name)
  }, [values.departureLocation?.name])

  useEffect(() => {
    if (!values?.arrivalLocation?.name) return

    emarsys.search.sendLocation('destination', values.arrivalLocation?.name)
  }, [values.arrivalLocation?.name])

  return null
}

export default SearchAnalytics
